import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  async getPulse(devices, type, mode = 'standard') {
    try {
      // Use satellite endpoint for sat mode when fetching GPS or RPM data
      const isSatMode = mode === 'sat';
      let processedType = type;

      if (isSatMode) {
        if (type === 'gps') {
          processedType = 'satellite/gps';
        } else if (type === 'rpm') {
          processedType = 'satellite/rpm';
        } else if (type === 'ae') {
          processedType = 'satellite/ae';
        }
      }

      const config = {
        params: { device: devices },
        cancelToken: getNewCancelToken(),
      };
      const response = await axiosInstance.get(`/series/device/${processedType}/pulse`, config);
      return response?.data?.data?.series || [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },
};
